import { FindexClient } from "@/integrations/findex";
import { useSession } from "@/modules/auth/hooks/useSession";
import { useAsyncAction } from "@/utils/async/useAsyncAction";
import { computed, reactive, type Ref } from "vue"

export type UseUserSettings = {
  currency: Ref<string>;
  loading: Ref<boolean>;
  refresh: () => void;

  setCurrency: (currency: string) => void;
}

type SettingsState = {
  currency: string;
  lastRefresh?: Date;
}

const state = reactive<SettingsState>({
  currency: 'SEK',
  lastRefresh: undefined
})

export const useUserSettings = (): UseUserSettings => {
  const session = useSession();

  const actionRefresh = useAsyncAction(async () => {
    const [ me ] = await FindexClient.whoami();
    if (!me) return;
    state.currency = me.currency || state.currency;
    state.lastRefresh = new Date();
  })

  const currency = computed(() => state.currency);

  const loading = computed(() => session.state.loading || actionRefresh.loading.value);

  const setCurrency = (currency: string) => {
    if (typeof currency !== 'string' || currency.length <= 1) return;
    state.currency = currency;
  }

  if (!state.lastRefresh || ((new Date().getTime() / 1000) - (state.lastRefresh.getTime() / 1000)) > 30) {
    actionRefresh.call();
  }

  return { currency, refresh: actionRefresh.call, loading, setCurrency };
}
